module.exports = __webpack_public_path__ + "img/红檀logo@2x.b894c260.png";